import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import InfiniteScroll from 'react-infinite-scroller';
import { makeSelectCurrentUserToken, makeSelectCurrentSite } from '../App/selectors';
import Loader from './loader';
import ProjectStory from '../..//components/StreamStories/project-story';
import PhotosStory from '../../components/StreamStories/photos-story';
import ArticleStory from '../../components/StreamStories/article-story';
import NewsroomStory from '../../components/StreamStories/newsroom-story';
import FolderStory from '../../components/StreamStories/folder-story';
import BookmarksStory from '../../components/StreamStories/bookmarks-story';
import ProductStory from '../../components/StreamStories/product-story';
import SuggestionsStory from '../../components/StreamStories/suggestions-story';
import { MostVisitedArticlesWidget, MostVisitedProductsWidget } from '../MostVisitedArticles';
import FolderRecommendationsWidget from '../FolderRecommendations';
import messages from './messages';
import { FormattedMessage } from 'react-intl';
import Follow from '../../components/Follow';
import { sendAnalyticsEvent } from '../../utils/helpers'

class Stream extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ready: false,
      error: null,
      hasMore: true,
      show: false,
    }
    this.stories = [];
    this.streamPage = 1;
    this.firstPage = true;
    this.fetchMoreData = this.fetchMoreData.bind(this);
    this.setStories = this.setStories.bind(this);
    this.gaEvents = {
      type: 'scroll'
    }
  }
  fetchMoreData() {
    Notifications.getNotifications(this.streamPage).then(response => {
      if (window.adInsights)
        window.adInsights.e('myad-feed', 'next-page', this.streamPage);
      this.setStories(response.notifications);
      this.streamPage = response.pagination.next_page;
      this.firstPage = false;
      this.setState({ hasMore: !response.pagination.last_page });
      sendAnalyticsEvent({ ...this.gaEvents })
    })

    if (localStorage.getItem('feed_welcome') !== null) return

    MyAD.checkTour("feed_welcome", null, data => {
      if (data["status"] === "seen") {
        localStorage.setItem('feed_welcome', 'done')
      } else if (data["status"] === "show") {
        this.setState({
          show: true,
        })
        if (window.adInsights) window.adInsights.e('onboarding', 'show', 'feed_welcome');
      }
    });
  };

  componentDidMount() {
    this.fetchMoreData();
  }

  componentDidUpdate() {
    MyAD.renderBookmarkLinks();
  }

  setStories(stories) {
    this.stories = this.stories.concat(stories);
    if (this.streamPage == 1) {
      this.setState({
        ready: true,
      });
    }
  }

  /** Alternates a limited number of posts and then a random section of recommended content, and so on */
  alternatePostsAndStories(basicStories, posts, limit) {
    const randomBasicStories = basicStories
      .map(a => [Math.random(), a])
      .sort((a, b) => a[0] - b[0])
      .map(a => a[1]);
    let alternatePosts = posts
      .map((story, index) =>
        index % 5 === 0 && index > 0 && randomBasicStories.length > 0
          ? [story, randomBasicStories.splice(0, 1)[0]]
          : story).flat();
    // check if we didn't fill the stream
    if (alternatePosts.length < limit) {
      alternatePosts = alternatePosts.concat(randomBasicStories);
    }
    return alternatePosts;
  }

  renderStories() {
    /* As per requirement, displaying only suggestions for categories. Other types might be enabled later. */
    let basicStories = [
      // { trigger: 'suggestions', type: 'author', meta: 'automatic' },
      // { trigger: 'suggestions', type: 'photographer', meta: 'automatic' },
      // { trigger: 'suggestions', type: 'office', meta: 'automatic' },
      // { trigger: 'suggestions', type: 'company', meta: 'automatic' },
      { trigger: 'suggestions', type: 'category', meta: 'automatic' },
      { trigger: 'suggestions', type: 'product_category', meta: 'automatic' }
      // { trigger: 'MostVisitedArticlesWidget', meta: 'automatic' },
      // { trigger: 'MostVisitedProductsWidget', meta: 'automatic' },
      // { trigger: 'FolderRecommendationsWidget', meta: 'automatic' },
    ];

    let stories = this.stories;
    if (this.firstPage) {

      stories = this.alternatePostsAndStories(basicStories, this.stories, 8);
      this.stories = this.stories.concat.apply([], stories);
    }

    return this.stories.map((story, index) => {
      switch (story.trigger) {
        case 'new_project':
          return <ProjectStory key={index.toString()} story={story} />
        case 'new_photo':
          return <PhotosStory key={index.toString()} story={story} />
        case 'new_article':
          return <ArticleStory key={index.toString()} story={story} />
        case 'article_published':
          return <NewsroomStory key={index.toString()} story={story} />
        case 'new_folder':
          return <FolderStory key={index.toString()} story={story} />
        case 'new_bookmark':
          return <BookmarksStory key={index.toString()} story={story} />
        case 'new_product':
          return <ProductStory key={index.toString()} story={story} />
        case 'suggestions':
          return <SuggestionsStory key={index.toString()} type={story.type} />
        case 'MostVisitedArticlesWidget':
          return <MostVisitedArticlesWidget key={index.toString()} />
        case 'MostVisitedProductsWidget':
          return <MostVisitedProductsWidget key={index.toString()} />
        case 'FolderRecommendationsWidget':
          return <FolderRecommendationsWidget key={index.toString()} />
        case 'follow':
          return <Follow key={index.toString()} story={story} />
      }
    });
  }

  renderWelcome() {
    return (
      <div className="afd-story--welcome">
        <h3 className="afd-title-big afd-title-big--bmargin-small afd-container-padding--m afd-title--center">
          <FormattedMessage {...messages.welcomeTitle} />
        </h3>
        <div className="afd-story--body afd-post-content">
          <p><FormattedMessage {...messages.welcomeParagraph} /></p>
        </div>
      </div>
    );
  }



  render() {
    if (this.state.ready) {
      return (
        <div className="myarchdaily-stream-wrapper">
          {this.state.show ? this.renderWelcome() : null}
          { // Do not use infinite scroll if there is only recommended content  
            this.stories.length <= 1 ?
              <Fragment>
                {this.renderStories()}
              </Fragment>
              : <InfiniteScroll
                pageStart={0}
                loadMore={this.fetchMoreData}
                hasMore={this.state.hasMore}
                loader={<Loader items="2" type='Feed' key={0} />}
              >
                {this.renderStories()}
              </InfiniteScroll>
          }
        </div>
      )
    } else {
      return (
        <Fragment>
          <div className="myarchdaily-stream-wrapper">
            <div>
              <Loader items="2" type='Feed' key={0} />
            </div>
          </div>
        </Fragment>
      )
    }
  }
}

const mapStateToProps = createStructuredSelector({
  token: makeSelectCurrentUserToken(),
  site: makeSelectCurrentSite(),
});

export default connect(mapStateToProps)(Stream);
